import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NotificationList } from '../../models/notification/notification-list.model';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  notificationList(): Observable<NotificationList[]> {
    let url = `${environment.apiLocations.notification}/NotificationMessage`;

    return this.http.get<NotificationList[]>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  unReadNotificationMessageCount(): Observable<number> {
    let url = `${environment.apiLocations.notification}/NotificationMessage/GetUnReadNotificationMessageCount`;

    return this.http.get<number>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  readNotification(notificationMessageId: string): Observable<boolean> {
    let url = `${environment.apiLocations.notification}/NotificationMessage/${notificationMessageId}`;

    return this.http.put<boolean>(
      url,
      {},
      { headers: this.headerHelperService.getHeaders() }
    );
  }

  readAllNotification(): Observable<boolean> {
    let url = `${environment.apiLocations.notification}/NotificationMessage/ReadAllNotificationMessage`;

    return this.http.put<boolean>(
      url,
      {},
      { headers: this.headerHelperService.getHeaders() }
    );
  }

  deleteNotification(notificationMessageId: string): Observable<void> {
    let url = `${environment.apiLocations.notification}/NotificationMessage/${notificationMessageId}`;

    return this.http.delete<void>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  deleteAllNotification(): Observable<void> {
    let url = `${environment.apiLocations.notification}/NotificationMessage/DeleteAllNotificationMessage`;

    return this.http.delete<void>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
